<app-navbar></app-navbar>

<section class="pt-0 pb-0" id="home">
    <div class="slider-bg">
        <ul class="slides">
            <li>
                <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStore">
                        <div class="slide-img" style="background-image: url('{{slide.image}}')">
                            <div class="hero-text-wrap">
                                <div class="hero-text white-color">
                                    <div class="container text-center">
                                        <h1 class="title raleway-font text-uppercase">{{slide.introtext}}</h1>
                                        <h2 class="white-color font-700 text-uppercase">{{slide.title}}</h2>
                                        <h3 class="sub-title font-100 raleway-font text-uppercase">{{slide.subtitle}}</h3>
                                        <a [routerLink]="'/about'" [ngClass]="slide.btnSlide"><span>{{slide.btnText}} <i class="icofont icofont-arrow-right"></i></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </li>
        </ul>
    </div>
</section>

<section class="white-bg xs-pb-100" id="features">
    <div class="container">
        <div class="row">
            <div *ngFor="let item of features;" class="col-md-4 col-sm-4 col-xs-12 mb-30 hover-effect">
                <div [ngClass]="item.featureBox">
                    <i [ngClass]="item.icon"></i>
                    <h4 class="mt-0 font-600 text-uppercase">{{item.title}}</h4>
                    <p class="font-400">{{item.desc}}</p>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen">
                    <img src="assets/images/about-heading-3.jpg" class="img-responsive" alt="about-heading-1" />
                </div>
            </div>
            <div class="col-md-6 col-sm-12 text-left d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0">
                    <div class="section-title mt-50">
                        <h2 class="raleway-font dark-color mt-0 text-uppercase">Restaurant Features</h2>
                        <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Enjoy An Exceptional Journey of Taste</h1>
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                        Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                        Phasellus tempus tellus vitae ullamcorper hendrerit.</p>
                    <p>Nulla luctus, tellus sed aliquam varius, mauris ligula lobortis lacus, condimentum aliquam odio felis
                        ullamcorper leo.</p>
                    <p class="mt-30 mb-0"><a class="btn btn-lg btn-animate-style-2 btn-square">Read more</a></p>
                </div>
            </div>
        </div>

        <div class="row mt-50">
            <div class="col-md-6 col-sm-12 text-left d-flex align-items-center">
                <div class="d-block pl-30 sm-pl-0 opening-content">
                    <div class="section-title mt-50">
                        <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Opening Time Hours</h1>
                    </div>
                    <ul>
                        <li><span>Monday - Friday :</span>  7:00 am - 22:00 pm</li>
                        <li><span>Saturday:</span>  8:00 am - 23:00 pm</li>
                        <li><span>Sunday:</span>  6:30 pm - 23:00 pm</li>
                        <li><span>Holidays:</span>  Closed</li>
                    </ul>
                    <div class="d-flex space-between">
                        <ul class="mr-20">
                            <h4 class="raleway-font text-uppercase">Breakfast</h4>
                            <li><span>Monday - Friday :</span>  7:00 am - 22:00 pm</li>
                            <li><span>Saturday:</span>  8:00 am - 23:00 pm</li>
                            <li><span>Sunday:</span>  6:30 pm - 23:00 pm</li>
                            <li><span>Holidays:</span>  Closed</li>
                        </ul>
                        <ul>
                            <h4 class="raleway-font text-uppercase">Lunch and Dinner</h4>
                            <li><span>Monday - Friday :</span>  7:00 am - 22:00 pm</li>
                            <li><span>Saturday:</span>  8:00 am - 23:00 pm</li>
                            <li><span>Sunday:</span>  6:30 pm - 23:00 pm</li>
                            <li><span>Holidays:</span>  Closed</li>
                        </ul>
                    </div>
                    <p class="mt-30 mb-0"><a class="btn btn-lg btn-animate-style-2 btn-square">Book a Table</a></p>
                </div>
            </div>

            <div class="col-md-6 col-sm-12">
                <div class="responsive-screen">
                    <img src="assets/images/about-heading-4.jpg" class="img-responsive" alt="about-heading-1" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="dark-bg" id="team">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font white-color mt-0 text-uppercase">Meet Ninjas</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Our Cheafs</h1>
                </div>
            </div>
        </div>

        <div class="row mt-50">
            <div class="team-slider">
                <div class="col-md-12">
                    <owl-carousel-o [options]="customOptionsTwo" class="owl-btn-center-lr">
                        <ng-template carouselSlide *ngFor="let slide of slideStoreTwo">
                            <div class="team-member">
                                <div class="team-thumb">
                                    <div class="thumb-overlay"></div>
                                    <img src="assets/images/team/{{slide.image}}" alt="">
                                    <div [ngClass]="slide.index === 0 ? 'member-info text-center gradient-bg-eleven' : 'member-info text-center gradient-bg-twelve'">
                                        <h3>{{slide.subtitle}}</h3>
                                        <span class="title">{{slide.title}}</span>
                                        <ul class="social-link list-inline">
                                            <li *ngFor="let social of socialLinks">
                                                <a href="#" [ngClass]="social.iconOuter"><i [ngClass]="social.iconInner"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>

    </div>
</section>


<section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font dark-color mt-0 text-uppercase">Where Flavor Meets Comfort</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Our Special Menu</h1>
                </div>
                
            </div>
        </div>

        <div class="row justify-content-center mt-50">
            <div class="col-md-8">
                <!-- Tabs Navigation -->
                <ul class="nav nav-tabs restaurant-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      [class.active]="activeTab === 'special-menu'"
                      (click)="setActiveTab('special-menu')"
                      id="special-menu"
                      type="button"
                      role="tab"
                      aria-controls="special-menu"
                      [attr.aria-selected]="activeTab === 'special-menu'">
                      Special Menu
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      [class.active]="activeTab === 'drinks'"
                      (click)="setActiveTab('drinks')"
                      id="drinks"
                      type="button"
                      role="tab"
                      aria-controls="drinks"
                      [attr.aria-selected]="activeTab === 'drinks'">
                      Drinks
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      [class.active]="activeTab === 'seafood'"
                      (click)="setActiveTab('seafood')"
                      id="seafood"
                      type="button"
                      role="tab"
                      aria-controls="seafood"
                      [attr.aria-selected]="activeTab === 'seafood'">
                      SeaFood
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      [class.active]="activeTab === 'desserts'"
                      (click)="setActiveTab('desserts')"
                      id="desserts"
                      type="button"
                      role="tab"
                      aria-controls="desserts"
                      [attr.aria-selected]="activeTab === 'desserts'">
                      Desserts
                    </button>
                  </li>
                </ul>
              
                <!-- Tabs Content -->
                <div class="tab-content">
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'special-menu'"
                    [class.active]="activeTab === 'special-menu'"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="special-menu">
                    <ul class="menu-list">
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Purple Corn Tostada</span><span class="price">$36</span></h5>
                            <p>Ricotta, goat cheese, beetroot and datterini.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Bruno's Scribble</span><span class="price">$59</span></h5>
                            <p>Culatello, Spalla Cotta, Mortadella, Culacciona.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Wild Mushroom Arancini</span><span class="price">$18</span></h5>
                            <p>Porcini purée, parmesan, basil.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Crispy Skin Chicken </span><span class="price">$25</span></h5>
                            <p>Ricotta, radicchio, prosciutto salad, cabernet.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'drinks'"
                    [class.active]="activeTab === 'drinks'"
                    id="drinks"
                    role="tabpanel"
                    aria-labelledby="drinks">
                    <ul class="menu-list">
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Purple Corn Tostada</span><span class="price">$36</span></h5>
                            <p>Ricotta, goat cheese, beetroot and datterini.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Bruno's Scribble</span><span class="price">$59</span></h5>
                            <p>Culatello, Spalla Cotta, Mortadella, Culacciona.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Wild Mushroom Arancini</span><span class="price">$18</span></h5>
                            <p>Porcini purée, parmesan, basil.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Crispy Skin Chicken </span><span class="price">$25</span></h5>
                            <p>Ricotta, radicchio, prosciutto salad, cabernet.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'seafood'"
                    [class.active]="activeTab === 'seafood'"
                    id="seafood"
                    role="tabpanel"
                    aria-labelledby="seafood">
                    <ul class="menu-list">
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Purple Corn Tostada</span><span class="price">$36</span></h5>
                            <p>Ricotta, goat cheese, beetroot and datterini.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Bruno's Scribble</span><span class="price">$59</span></h5>
                            <p>Culatello, Spalla Cotta, Mortadella, Culacciona.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Wild Mushroom Arancini</span><span class="price">$18</span></h5>
                            <p>Porcini purée, parmesan, basil.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Crispy Skin Chicken </span><span class="price">$25</span></h5>
                            <p>Ricotta, radicchio, prosciutto salad, cabernet.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                    </ul>
                  </div>
                  <div
                    class="tab-pane fade"
                    [class.show]="activeTab === 'desserts'"
                    [class.active]="activeTab === 'desserts'"
                    id="desserts"
                    role="tabpanel"
                    aria-labelledby="desserts">
                    <ul class="menu-list">
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Purple Corn Tostada</span><span class="price">$36</span></h5>
                            <p>Ricotta, goat cheese, beetroot and datterini.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Bruno's Scribble</span><span class="price">$59</span></h5>
                            <p>Culatello, Spalla Cotta, Mortadella, Culacciona.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Wild Mushroom Arancini</span><span class="price">$18</span></h5>
                            <p>Porcini purée, parmesan, basil.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Crispy Skin Chicken </span><span class="price">$25</span></h5>
                            <p>Ricotta, radicchio, prosciutto salad, cabernet.</p>
                        </li>
                        <li>
                            <h5 class="name"><span class="txt">Tender Octopus and Fennel</span><span class="price">$25</span></h5>
                            <p>Citrus, wild rocket condiment.</p>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              
        </div>

    </div>
</section>

<section class="dark-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font white-color mt-0 text-uppercase">About Restaurant</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Your Table Awaits</h1>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-7 col-xs-12">
                <img class="img-responsive" src="assets/images/about-heading-5.jpg" alt="about-heading-2">
            </div>
            <div class="col-md-5 mt-30 col-xs-12">
                <div class="skillbar-wrap skillbar-style-01">
                    <div *ngFor="let skill of skills" class="pl-30 sm-pl-0">
                        <div class="skillbar">
                            <span class="skillbar-title text-uppercase white-color">{{ skill.name }}</span>
                            <p class="skillbar-bar gradient-bg-twelve" role="progressbar" [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"></p>
                            <span class="skill-bar-percent white-color">{{ skill.level }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="gradient-bg-twelve xs-pb-60">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/bg-left-img-2.jpg);">
            <div class="video-box_overlay">
                <div class="center-layout">
                    <div class="v-align-middle"> 
                        <a (click)="openPopup()">
                            <div class="play-button"><i class="tr-icon ion-android-arrow-dropright"></i></div>
                        </a> 
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="col-md-6 col-sm-6 offset-md-6 offset-md-6">
            <div class="col-inner spacer white-color text-center">
                <h2 class="raleway-font mt-0 font-20px xs-font-17px text-uppercase">Our Amazing Story</h2>
                <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px text-uppercase">Watch Our Video</h1>
                <p>Objectively innovate empowered manufactured products whereas parallel platforms.<br>
                    Holisticly predominate extensible testing procedures for reliable supply chains. </p>
                <p><a href="javascript:void(0)" class="btn btn-md btn-square btn-light-outline mt-30">Meet The Team</a></p>
            </div>
        </div>
    </div>
</section>

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/sU3FkzUKHXU?si=vhtmR7XG-9HXU6Ij" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='icofont icofont-close'></i>
        </button>
    </div>
</div>

<section class="grey-bg" id="portfolio">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font dark-color mt-0 text-uppercase">Show Your Food Gallery</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Food That Makes You Smile</h1>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row mt-50">
            <div *ngFor="let portfolio of portfolios" class="col-md-3 col-sm-6 portfolio with-spacing">
                <div class="portfolio-item border-white-15">
                    <a href="javascript:void(0)">
                        <img src="assets/images/portfolio/grid/{{portfolio.img}}" alt="">
                        <div class="portfolio-info gradient-bg-twelve">
                            <div class="centrize">
                                <div class="v-center white-color">
                                    <h3 class="text-uppercase">{{portfolio.title}}</h3>
                                    <p>{{portfolio.subTitle}}</p>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="dark-bg" id="pricings">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font white-color mt-0 text-uppercase">Select Your Plan</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Our Pricing Table</h1>
                </div>
            </div>
        </div>
        <div class="row mt-50">
            <div *ngFor="let price of pricing; let i = index" class="col-md-4 pricing-table col-sm-4 xs-mb-30 hover-effect">
                <div class="pricing-box border-radius-25 {{ i === 1 ? 'pricing-box-gradient-six' : 'pricing-box-gradient-nine' }} text-center white-color">
                    <h3 class="mb-0 raleway-font text-uppercase">{{price.title}}</h3>
                    <h2 class="font-60px sm-font-40px"><sup>{{price.currency}}</sup><span>{{price.amount}}</span></h2>
                    <ul class="list-style-02">
                        <li *ngFor="let feature of price.features">{{ feature }}</li>
                    </ul>
                    <div class="pricing-box-bottom"> <a [ngClass]="price.btnClass">{{price.btnText}}</a> </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font dark-color mt-0 text-uppercase">What Our Client Says</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Our Testimonials</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <owl-carousel-o [options]="customOptionsThree" class="testimonial gradient-bullet-five owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreThree">
                        <div class="testimonial-item">
                            <div class="testimonial-content border-radius-25">
                                <img class="img-responsive rounded-circle text-center" src="{{slide.image}}" alt="" />
                                <h4 class="font-600 mb-0 raleway-font text-uppercase">{{slide.title}}</h4>
                                <span class="orange-color font-14px text-uppercase">{{slide.subTitle}}</span>
                                <div class="clearfix mb-20"></div>
                                <i class="icofont icofont-quote-left font-50px orange-color mt-20"></i>
                                <p class="mt-20 line-height-26 font-14px">{{slide.description}}</p>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>

<div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div>

<section class="gradient-bg-twelve xs-pb-60" id="blog">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/blog-img.jpg);"></div>
    </div>
    <div class="container-fluid">
        <div class="col-md-6 col-sm-6">
            <div class="col-inner spacer white-color text-center">
                <h2 class="raleway-font mt-0 font-20px xs-font-17px text-uppercase">Read Our News</h2>
                <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px text-uppercase">Latest Blog Post</h1>
                <p>Objectively innovate empowered manufactured products whereas parallel platforms.<br> Holisticly
                    predominate extensible testing procedures for reliable supply chains. </p>
                <p><a routerLink="/blog-details" class="btn btn-md btn-square btn-light-outline mt-30">See Blog Details</a></p>
            </div>
        </div>
    </div>
</section>

<section class="white-bg transition-none" id="contact">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font dark-color mt-0 text-uppercase">Just Keep In Touch</h2>
                    <h1 class="raleway-font orange-color mt-30 font-50px font-300 text-uppercase">Contact Us Now</h1>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row mt-70">
            <div class="col-md-6 col-sm-6 col-xs-12 xs-mb-50">
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font orange-color">Postal Address</h2>
                            <p class="mt-30">PO Box 16122 Toronto Eaton Centre, 220 The PATH Toronto, ON M5B 2H1, Canada
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font orange-color">Office Numbers</h2>
                            <p class="mb-0 mt-30">Landline : +44 1234 567 9</p>
                            <p class="mb-0">Mobile : +44 1234 567 9</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font orange-color">Our Email</h2>
                            <p class="mb-0 mt-30">Order : order&#64;yourwebsite.com</p>
                            <p class="mb-0">Request : request&#64;yourwebsite.com</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <div class="section-title">
                            <h2 class="raleway-font orange-color">Fast Support</h2>
                            <p class="mb-0 mt-30">Support : support&#64;yourwebsite.com</p>
                            <p class="mb-0">Career : career&#64;yourwebsite.com</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-20">
                    <div class="col-md-12 social-icons-style-01">
                        <ul class="md-icon left-icon">
                            <li *ngFor="let social of socialMedia">
                                <a [ngClass]="social.iconClass" href="javascript:void(0)"><i [ngClass]="social.icon"></i></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <form (submit)="sendEmail($event)" class="contact-form-style-01" #contactForm="ngForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="form-group">
                                <label class="visually-hidden" for="user_name">Name</label>
                                <input type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched" name="user_name" class="md-input" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mb-10">
                                    Name is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="mb-3">
                                <label class="visually-hidden" for="user_email">Email</label>
                                <input type="email" minlength="2" maxlength="35"
                                    [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email"
                                    class="md-input" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                    #userEmail="ngModel" required email>
                                <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mb-10">
                                    A valid email is required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="mb-3">
                                <label class="visually-hidden" for="message">Project Details</label>
                                <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched"
                                    class="md-textarea" id="message" rows="7" placeholder="Project Details"
                                    [(ngModel)]="formData.message" #userMessage="ngModel" required></textarea>
                                <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                    Project details are required.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="text-left mt-20">
                                <button type="submit" name="submit" class="btn btn-outline btn-md btn-circle btn-animate remove-margin" [disabled]="contactForm.invalid" value="Send">
                                    <span>Send Message <i class="ion-android-arrow-forward"></i></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    </div>
</section>


